module.exports = __webpack_public_path__ + "img/commission.8bc88ebb.png";